<template>
    <div v-if="model && form">
        <rkm-area
            title="Filtros"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        label="Vacina"
                        :options="vacinasParam"
                        v-model="model.vacinaId"
                        show-default-option
                        default-option-text="Todas"
                        text-field="nome"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Unidade"
                        :options="form.unidades"
                        v-model="model.unidadeId"
                        show-default-option
                        default-option-text="Todas"
                        text-field="nomeFantasia"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="list"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clearForm"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Resultado"
            type="fieldset"
            v-if="estoque.length > 0"
        >
            <rkm-table
                :fields="fields"
                :items="estoque"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="getEstoque(item.vacinaId)"
                        title="Detalhes"
                        color="primary"
                        small
                    >
                        <rkm-icon icon="search"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            ref="Modal"
            :enums="enums"
            :additionals="additionals"
        />
    </div>
</template>

<script>
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import { error, repository } from '@/mixins'
import { mapActions } from 'vuex'
import Modal from './Modal'

export default {
    components: {
        Modal
    },
    created() {
        this.repository = {
            consultaEstoque: this.getConectaSusRepository('imunizacao.consultaEstoque')
        }
        this.load()
    },
    computed: {
        fields() {
            const commonFields = []
            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    commonFields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;
                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;
                default:
                    commonFields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }
            return commonFields.concat([
                {
                    key: 'estoque',
                    label: 'Estoque'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ])
        }
    },
    data: () => {
        return  {
            model: null,
            form: null,
            parametrizacao: null,
            estoque: [],
            enums: {
                parametrizacaoDescricaoVacina
            },
            vacinasParam:[]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repository.consultaEstoque.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                    this.additionals = data.additionals                   

                    var vacinas = data.form.vacinas;
                    switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                        case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaAbreviacao });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaSigla });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaSiglaNome });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaSiglaAbreviacao });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaAbreviacaoNome });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaSiglaAbreviacaoNome });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                        default:       
                            for (let vacinaKey in vacinas) {
                                this.vacinasParam.push({ id: vacinas[vacinaKey].vacinaId, nome: vacinas[vacinaKey].vacinaNome });
                            }
                            this.vacinasParam.sort((a, b) => a.nome.localeCompare(b.nome));
                            break;
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.setLoading()
            this.repository.consultaEstoque.list({
                vacina_id: this.model.vacinaId,
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {
                    this.estoque = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidades() {
            this.setLoading()
            this.repository.consultaEstoque.getUnidades({
                vacina_id: this.model.vacinaId
            })
                .then(({ data }) => {
                    this.form.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEstoque(id) {
            this.setLoading()
            this.repository.consultaEstoque.getEstoque({
                vacina_id: id,
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {
                    this.$refs.Modal.open(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearForm() {
            this.vacinaId = null
            this.estoque = []
        }
    },
    watch: {
        'model.vacinaId': function() {
            if(this.model.vacinaId) {
                this.getUnidades()
            }
        },
        'model.unidadeId': function() {
            this.estoque = []
        }
    },
    mixins: [ error, repository ],
}
</script>